<script lang="ts">
  export let color: string = "";
  export let opacity: number | null;
  export let active: boolean = true;
  export let backgroundClass: string = "bg-gray-400 dark:bg-gray-300";
  // reactively normalize opacity value if needed
  $: if (opacity && opacity > 1 && opacity <= 100) {
    opacity = opacity / 100;
  }
</script>

{#if color}
  <!-- add additional background of opposite colour to make it pop -->
  <div
    class="absolute inset-0 bg-black transition-[colors,opacity] duration-100 dark:bg-white"
    style:opacity={active ? 0.09 : 0}
  />
{/if}
<div
  style:background={color}
  style:opacity={active ? opacity : 0}
  style:transition="background-color 300ms linear, opacity 200ms linear"
  class="absolute inset-0 {backgroundClass}"
/>
